import { useState, useEffect } from 'react';
import { FGCheckbox, FGInput, FGInputField, FGButton, FGPassword } from '@fg/design-system';
import { getCookie, setCookie, deleteCookie } from '../services/cookieHelper';
import { callPiwik } from '../services/Login';
type Props = {
  loginAPICall: Function;
  setErrorMessage: Function;
  appCode: string;
  email: string;
};
export const SignInView = ({ loginAPICall, setErrorMessage, appCode, email }: Props) => {
  const id = 'sing-in-view';
  const userEmail = sessionStorage.getItem('userEmail');
  const rememberUsername = getCookie('remember');
  const usernameInputValue = email || rememberUsername || userEmail || '';
  const checkRememberMe = rememberUsername ? true : false;
  const [username, setUsername] = useState(usernameInputValue);
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  useEffect(() => {
    setRememberMe(checkRememberMe);
  }, [checkRememberMe]);
  const callLogin = (e) => {
    e.preventDefault();
    if (!username || !password) {
      if (appCode === 'creditSights') {
        setErrorMessage('Please enter a valid email and password.');
      } else {
        setErrorMessage('Please enter a valid username and password.');
      }
      return false;
    }

    const payload = { username: username.trim(), password: password };

    loginAPICall(payload).then((response) => {
      if (response) {
        var rememberMeCookie = getCookie('remember');
        const rememberMeExpirationDays = 90;
        if (rememberMe && (!rememberMeCookie || username !== rememberMeCookie)) {
          setCookie('remember', username, rememberMeExpirationDays);
        }
        if (!rememberMe && getCookie('remember') != null) {
          deleteCookie('remember');
        }
        window.location.href = response.redirectURL;

        callPiwik(['setUserId', response.userId]);
        callPiwik(['trackEvent', 'Login-Credentials', 'Click', 'Successful_Log_In']);
      }
    });
    return false;
  };
  const handleChange = (e) => {
    if (e.target.name === 'username') {
      setUsername(e.target.value.trimStart());
    } else {
      setPassword(e.target.value);
    }
  };
  const setRememberMeCall = (e) => {
    setRememberMe(e.target.checked);
  };
  const handleKeypress = (e) => {
    if (e.charCode === 13 && username && password) {
      callLogin(e);
    }
  };
  function getSignInEmailLabel() {
    switch (appCode) {
      case 'creditSights':
        return 'Email';
      case '':
        return 'Email or Username';
      default:
        return 'Username';
    }
  }
  return (
    <div className="fg-mg--t10 fg-fxd--c tab-panel-content">
      <FGInputField id={`${id}-sign-in-email`} label={getSignInEmailLabel()}>
        <FGInput
          size="l"
          id={`${id}-sign-in-email`}
          onKeyPress={handleKeypress}
          autoFocus
          autoComplete="username"
          name="username"
          value={username}
          onChange={handleChange}
        />
      </FGInputField>
      <FGInputField id={`${id}-sign-in-password`} label="Password">
        <FGPassword
          size="l"
          id={`${id}-sign-in-password`}
          onChange={handleChange}
          onKeyPress={handleKeypress}
          name="password"
          autoComplete="current-password"
        />
      </FGInputField>
      <FGInputField id={`${id}-sign-in-remember`}>
        <FGCheckbox
          label="Remember me"
          name="rememberMe"
          checked={rememberMe}
          onChange={setRememberMeCall}
          id={`${id}-sign-in-remember`}
        />
      </FGInputField>
      <div className="fg-pd--y6" style={{ display: 'inline-grid' }}>
        <FGButton size="xl" onClick={callLogin}>
          {' '}
          Sign In{' '}
        </FGButton>
      </div>
    </div>
  );
};
